export default {
    FETCHED_TRADITIONAL_FACTORY: 'FETCHED_TRADITIONAL_FACTORY',
    FETCHED_TRADITIONAL_FACTORY_DETAILS: 'FETCHED_TRADITIONAL_FACTORY_DETAILS',
    FETCHED_TRADIONAL_MERCHANT_PENDING: 'FETCHED_TRADIONAL_MERCHANT_PENDING'
}